import { FC } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { ResultSearchType } from '@savgroup-front-common/core/molecules/SearchWithDimmer/SearchWithDimmer.types';
import { Badge } from '@savgroup-front-common/primitive/ui/badge';
import { RESULT_TYPE } from '@savgroup-front-common/types';

import { getResultRowIconStyle } from './AppBarSearchResultRow.helpers';

interface AppBarSearchResultRowProps {
  icon?: string;
  type?: RESULT_TYPE;
  hit: ResultSearchType;
  onSelect: () => void;
}

export const AppBarSearchResultRow: FC<AppBarSearchResultRowProps> = ({
  icon,
  type,
  hit,
  onSelect,
}) => {
  const { formatDate } = useIntl();
  const { icon: iconElement, className: iconClassName } =
    getResultRowIconStyle(icon);

  const isOrder = type === RESULT_TYPE.ORDER;
  const subtitle =
    isOrder && hit.purchaseDate
      ? formatDate(hit.purchaseDate, {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
        })
      : hit.searchLocalizedInfo;

  return (
    <Link
      to={hit.searchUrl ?? '#'}
      onClick={onSelect}
      data-testid="appBarSearchResultLink"
      className="flex items-center gap-3 rounded-sm px-2 py-2 hover:bg-surface-base-hover"
    >
      <Badge
        shape="square"
        className={`size-8 gap-0 border-0 p-0 [&>svg]:size-5! ${iconClassName}`}
      >
        {iconElement}
      </Badge>
      <span className="flex min-w-0 flex-1 flex-col">
        <span className="truncate text-sm font-medium stext-base-default">
          {hit.searchReference}
          {subtitle && ` — ${subtitle}`}
        </span>
        <span className="truncate text-xs stext-muted-default">
          {hit.searchFirstName} {hit.searchLastName}
        </span>
      </span>
    </Link>
  );
};
